<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Cash/Bank Receipt Form
        <div class="card-header-actions">
          <button class="btn btn-danger mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="8">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Trx. Number</label></b-input-group-prepend>
                <b-form-input v-model="model.nomor" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend><label>Trx. Date</label></b-input-group-prepend>
                <b-form-input v-model="model.tanggal" type="date" @change="tanggalBerubah" :state="!$v.model.tanggal.$error"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
            <b-form-input v-model="model.uraian" :state="!$v.model.uraian.$error"></b-form-input>
          </b-input-group>
          <b-row>
            <b-col lg="8">
              <b-input-group>
                <b-input-group-prepend><label>Receipt From</label></b-input-group-prepend>
                <b-form-input v-model="model.terimadari" :state="!$v.model.terimadari.$error"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="4">
              <b-input-group>
                <b-input-group-prepend class="d-md-inline d-lg-none"><label>Receive Method</label></b-input-group-prepend>
                <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Receive Method</span></b-input-group-prepend>
                <b-form-select v-model="model.jenis" :plain="true" :options="jenisPaym" :state="!$v.model.jenis.$error"></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="4" v-if="model.jenis === 'Cheque' || model.jenis === 'Giro'">
              <b-input-group>
                <b-input-group-prepend><label>Cheque/Giro No.</label></b-input-group-prepend>
                <b-form-input v-model="model.nomor_cek"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="4" v-if="model.jenis === 'Cheque' || model.jenis === 'Giro'">
              <b-input-group>
                <b-input-group-prepend><label>Cheque/Giro Date</label></b-input-group-prepend>
                <b-form-input v-model="model.tgl_giro" type="date"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="4">
              <b-input-group>
                <b-input-group-prepend><label>Due/Efective Date</label></b-input-group-prepend>
                <b-form-input v-model="model.tgl_terima" type="date"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend><label>Cash/bank Account</label></b-input-group-prepend>
                <b-form-input readonly v-model="model.namabank" @keyup.13.native="lkuBankaccountShow = true" :state="!$v.model.kodebank.$error"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuBankaccountShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
                <b-input-group-append>
                  <span class="input-group-text" style="width: 70px">{{ model.matauang }}</span>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="5" v-if="bankOnly == '1'">
              <b-input-group>
                <b-input-group-prepend class="d-md-inline d-lg-none"><label>Bank Account No.</label></b-input-group-prepend>
                <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Bank Account#</span></b-input-group-prepend>
                <b-form-input disabled v-model="model.nomorrek"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <!-- <b-row>
                    <b-col lg="5">
                        <b-input-group >
                            <b-input-group-prepend><label>Trx. Amount</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" separator="," v-model="model.valas_in" :precision="2" :state="!$v.model.valas_in.$error" v-b-tooltip.hover title="EXCLUDE Bank Charges"></my-number>
                        </b-input-group>
                    </b-col>
                    <b-col lg="3">
                        <b-input-group >
                            <b-input-group-prepend><label>Bank Charges</label></b-input-group-prepend>
                                <b-input-group-prepend class="d-md-inline d-lg-none"><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" separator="," v-model="model.bcharge" :precision="2"></my-number>
                        </b-input-group>
                    </b-col>
                    <b-col lg="4">
                        <b-input-group >
                            <b-input-group-prepend><label>Exch. Rate {{model.matauang || ''}}</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{uanguser}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" separator="," v-model="model.kurstrx" :precision="6"></my-number>
                        </b-input-group>
                    </b-col>
                </b-row> -->
          <b-input-group>
            <b-input-group-prepend><label>iDocs Documents</label></b-input-group-prepend>
            <b-input-group-prepend>
              <span class="input-group-text">BANK/KAS MASUK</span>
            </b-input-group-prepend>
            <b-form-input v-model="model.iDocsURL" placeholder="iDocs URL" :state="!$v.model.iDocsURL.$error"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="show_iDocs()">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-append v-if="model.iDocsURL">
              <b-btn text="Button" variant="success" @click="open_iDocs()"> Open </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <v-dim :model="model" :key="updateDimHdr"></v-dim>
          <b-input-group>
            <b-input-group-prepend><label>Trx. Amount</label></b-input-group-prepend>
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{ model.matauang }}</span></b-input-group-prepend
            >
            <my-number
              class="form-control text-right"
              separator=","
              v-model="model.valas_in"
              :precision="2"
              :state="!$v.model.valas_in.$error"
              v-b-tooltip.hover
              title="EXCLUDE Bank Charges"
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Bank Charges</label></b-input-group-prepend>
            <b-input-group-prepend class="d-md-inline d-lg-none"
              ><span class="input-group-text" style="width: 70px">{{ model.matauang }}</span></b-input-group-prepend
            >
            <my-number class="form-control text-right" separator="," v-model="model.bcharge" :precision="2"></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label>Exch. Rate {{ model.matauang || "" }}</label></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{ uanguser }}</span></b-input-group-prepend
            >
            <my-number class="form-control text-right" separator="," v-model="model.kurstrx" :precision="6"></my-number>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body>
        <b-tabs card v-model="tabIndex">
          <b-tab title="AR Receipt" active>
            <b-row class="mt-2 mr-3">
              <b-col class="pr-4" cols="8">
                <b-input-group>
                  <b-input-group-prepend><label>AR Payment Settle.#</label></b-input-group-prepend>
                  <b-form-input readonly v-model="arReceipt.paymno" @keyup.13.native="lkuArsetShow = true" :state="!$v.arReceipt.arpaymKey.$error"></b-form-input>
                  <b-input-group-append>
                    <b-btn text="Button" @click="lkuArsetShow = true" id="arCollection">
                      <i class="fa fa-search"></i>
                    </b-btn>
                  </b-input-group-append>
                  <b-input-group-prepend><scpan class="p-2">Customer</scpan></b-input-group-prepend>
                  <b-form-input v-model="arReceipt.custinfo" readonly style="width: 33% !important"></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend><label>Cashflow Account</label></b-input-group-prepend>
                  <b-form-input readonly v-model="model.cashflow" @keyup.13.native="showLkuCashflow('model')"></b-form-input>
                  <b-input-group-append>
                    <b-btn text="Button" @click="showLkuCashflow('model')">
                      <i class="fa fa-search"></i>
                    </b-btn>
                  </b-input-group-append>
                  <b-form-input v-model="arReceipt.uraian" readonly class="ml-2"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col class="pr-4" cols="4">
                <b-input-group>
                  <b-input-group-prepend><label>Total Payment</label></b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text" style="width: 70px">{{ arReceipt.matauang }}</span>
                  </b-input-group-prepend>
                  <my-number class="form-control text-right" v-model="arReceipt.totalbyr" :precision="2" disabled></my-number>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend><label>Total AR Settlement</label></b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text" style="width: 70px">{{ arReceipt.matauang }}</span>
                  </b-input-group-prepend>
                  <my-number class="form-control text-right" v-model="arReceipt.settl_amt" :precision="2" disabled></my-number>
                </b-input-group>
              </b-col>
            </b-row>

            <b-table
              class="mb-0"
              ref="tblArReceipt"
              outlined
              striped
              hover
              small
              style="font-size: smaller"
              :items="arReceipt.items"
              :fields="arReceipt.fields"
              :current-page="arReceipt.page"
              :per-page="arReceipt.limit"
              :key="arReceipt.paymno"
            >
              <template v-slot:cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template v-slot:cell(nilaibyr)="data">
                {{ data.item.nilaibyr | numFormat }}
              </template>
              <template v-slot:cell(kurskeAR)="data">
                {{ data.item.kurskeAR | numFormat("0.000") }}
              </template>
              <template v-slot:cell(nilaibank)="data">
                {{ data.item.nilaibank | numFormat }}
              </template>
              <template v-slot:cell(selisihkurs)="data">
                {{ data.item.selisihkurs | numFormat("0,0.00") }}
              </template>
            </b-table>
            <b-row>
              <b-col cols="4">
                <div class="ml-2">
                  Showing {{ (arReceipt.page - 1) * arReceipt.limit + 1 }} to <span v-if="arReceipt.page * arReceipt.limit > arReceipt.total">{{ arReceipt.total }}</span>
                  <span v-else>{{ arReceipt.page * arReceipt.limit }}</span> of {{ arReceipt.total }} entries
                </div>
              </b-col>
              <b-col cols="4">
                <b-form-group label-cols="3" label="Limit per page" style="margin-top: 0 !important">
                  <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="arReceipt.limit" size="sm" style="width: 80px" />
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-pagination align="right" :total-rows="arReceipt.total" :per-page="arReceipt.limit" v-model="arReceipt.page"></b-pagination>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Adv.Settle (Excess Cash)">
            <b-table
              class="mb-0"
              ref="tblAdvSetPayment"
              outlined
              striped
              hover
              small
              style="font-size: smaller"
              :items="advSetPayment.items"
              :fields="advSetPayment.fields"
              :current-page="advSetPayment.page"
              :per-page="advSetPayment.limit"
            >
              <template v-slot:cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template v-slot:cell(nilaiByr)="data">
                {{ data.item.nilaiByr | numFormat }}
              </template>
              <template v-slot:cell(kursBankKeAdv)="data">
                {{ data.item.kursBankKeAdv | numFormat("0.000") }}
              </template>
              <template v-slot:cell(nilaiBank)="data">
                {{ data.item.nilaiBank | numFormat }}
              </template>
              <template v-slot:cell(selisihKurs)="data">
                {{ data.item.selisihKurs | numFormat("0,0.00") }}
              </template>
              <template v-slot:cell(iDocsURL)="data">
                <b-link @click="open_iDoc(data.item)" v-if="data.item.iDocsURL">iDoc</b-link>
              </template>

              <template v-slot:cell(action)="data">
                <div class="text-center">
                  <a href="javascript:void(0)" @click="editAdvSetPayment(data.item, data.toggleDetails)">
                    <i class="fa fa-pencil"></i>
                  </a>
                  |
                  <a href="javascript:void(0)" class="text-danger" @click="delAdvSetPayment(data.index)">
                    <i class="fa fa-trash"></i>
                  </a>
                </div>
              </template>
              <template v-slot:row-details="row">
                <b-card no-body class="row-details-form">
                  <b-row class="mt-2">
                    <b-col class="pr-4" cols="6">
                      <b-form-group label-cols="3" label-for="advSetNumber" label="Advance Settlement No.">
                        <b-input-group>
                          <b-form-input readonly v-model="advSetPayment.obj.nomor" @keyup.13.native="lkuAdvSetShow = true" :state="!$v.advSetPayment.obj.advSttlKey.$error"></b-form-input>
                          <b-input-group-append>
                            <b-btn text="Button" @click="lkuAdvSetShow = true" id="advSetNumber">
                              <i class="fa fa-search"></i>
                            </b-btn>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group label-cols="3" label="Employee">
                        <b-form-input v-model="advSetPayment.obj.crewinfo" readonly></b-form-input>
                      </b-form-group>
                      <b-form-group label-cols="3" label="Description">
                        <b-form-input v-model="advSetPayment.obj.keterangan" disabled></b-form-input>
                      </b-form-group>
                      <b-form-group label-cols="3" label="Outstanding Exceeds Cash">
                        <b-input-group>
                          <b-input-group-prepend>
                            <span class="input-group-text" style="width: 70px">{{ advSetPayment.obj.matauang }}</span>
                          </b-input-group-prepend>
                          <my-number class="form-control text-right" v-model="advSetPayment.obj.outstand" :precision="2" disabled></my-number>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col class="pr-4" cols="6">
                      <b-form-group label-cols="3" label="Payment in Original Amount">
                        <b-input-group>
                          <b-input-group-prepend>
                            <span class="input-group-text" style="width: 70px">{{ advSetPayment.obj.matauang }}</span>
                          </b-input-group-prepend>
                          <my-number
                            class="form-control text-right"
                            v-model="advSetPayment.obj.nilaiByr"
                            :precision="2"
                            :state="!$v.advSetPayment.obj.nilaiByr.$error"
                            @change="updateAdvSetpaym"
                          ></my-number>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group label-cols="3" label="Payment in Cash/Bank Amt.">
                        <b-input-group>
                          <b-input-group-prepend>
                            <span class="input-group-text" style="width: 70px">{{ model.matauang }}</span>
                          </b-input-group-prepend>
                          <my-number class="form-control text-right" v-model="advSetPayment.obj.nilaiBank" :precision="2" :state="!$v.advSetPayment.obj.nilaiBank.$error"></my-number>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group label-cols="3" label="Exchange Rate Bank to Orig.Amt">
                        <b-input-group>
                          <b-input-group-prepend>
                            <span class="input-group-text pl-2 pr-2">{{ model.matauang }} to {{ advSetPayment.obj.matauang }} </span>
                          </b-input-group-prepend>
                          <my-number class="form-control text-right" v-model="advSetPayment.obj.kursBankKeAdv" :precision="6" :state="!$v.advSetPayment.obj.kursBankKeAdv.$error"></my-number>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group label-cols="3" label-for="advSetKodecash" label="Cash Flow">
                        <b-input-group>
                          <b-form-input readonly v-model="advSetPayment.obj.cashflow" @keyup.13.native="showLkuCashflow('advSetPayment')" :state="!$v.advSetPayment.obj.kodecash.$error"></b-form-input>
                          <b-input-group-append>
                            <b-btn text="Button" @click="showLkuCashflow('advSetPayment')" id="advSetKodecash">
                              <i class="fa fa-search"></i>
                            </b-btn>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="justify-content-center mb-2">
                    <div style="width: 400px">
                      <b-input-group>
                        <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                        <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0" class="pt-2"></b-form-checkbox>
                        <b-input-group-append>
                          <b-button class="btn btn-success mr-1" @click="saveAdvSetPayment()">Update</b-button>
                        </b-input-group-append>
                        <b-input-group-append>
                          <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                  </b-row>
                </b-card>
              </template>
            </b-table>
            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-button size="sm" class="ml-3" @click="addAdvSetPayment" :disabled="!model.kodebank">Add Advance Settlement Payment</b-button>
                  <div class="ml-2">
                    Showing
                    {{ (advSetPayment.page - 1) * advSetPayment.limit + 1 }}
                    to
                    {{ advSetPayment.page * advSetPayment.limit }}
                    of
                    {{ advSetPayment.total }}
                    entries
                  </div>
                </b-row>
              </b-col>
              <b-col cols="6">
                <b-pagination align="right" :total-rows="advSetPayment.total" :per-page="advSetPayment.limit" v-model="advSetPayment.page"></b-pagination>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Other">
            <b-table class="mb-0" ref="tblOthPayment" outlined striped hover small :items="othPayment.items" :fields="othPayment.fields" :current-page="othPayment.page" :per-page="othPayment.limit">
              <template v-slot:cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template v-slot:cell(ukeluar)="data">
                {{ data.item.ukeluar | numFormat }}
              </template>
              <template v-slot:cell(action)="data">
                <div class="text-center">
                  <a href="javascript:void(0)" @click="editOthPayment(data.item, data.toggleDetails)">
                    <i class="fa fa-pencil"></i>
                  </a>
                  |
                  <a href="javascript:void(0)" class="text-danger" @click="delOthPayment(data.index)">
                    <i class="fa fa-trash"></i>
                  </a>
                </div>
              </template>
              <template v-slot:row-details="row">
                <b-card no-body class="row-details-form">
                  <b-row class="mt-2">
                    <b-col class="pr-4" cols="6">
                      <b-form-group label-cols="3" label-for="glAccount" label="GL Account No.">
                        <b-input-group>
                          <b-form-input readonly v-model="othPayment.obj.glAccount" @keyup.13.native="lkuCoaShow = true" :state="!$v.othPayment.obj.kodeacc.$error"></b-form-input>
                          <b-input-group-append>
                            <b-btn text="Button" @click="lkuCoaShow = true" id="glAccount">
                              <i class="fa fa-search"></i>
                            </b-btn>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group label-cols="3" label="Description">
                        <b-form-input v-model="othPayment.obj.uraian" :state="!$v.othPayment.obj.uraian.$error"></b-form-input>
                      </b-form-group>
                      <b-form-group label-cols="3" label="Payment in Cash/Bank Amt.">
                        <b-input-group>
                          <b-input-group-prepend>
                            <span class="input-group-text" style="width: 70px">{{ model.matauang }}</span>
                          </b-input-group-prepend>
                          <my-number class="form-control text-right" separator="," v-model="othPayment.obj.ukeluar" :minus="true" :precision="2" :state="!$v.othPayment.obj.ukeluar.$error"></my-number>
                          <b-input-group-append
                            ><span class="pt-2 ml-1">CR &nbsp; ( <i class="fa fa-minus-square"></i> DB)</span></b-input-group-append
                          >
                        </b-input-group>
                      </b-form-group>
                      <b-form-group label-cols="3" label-for="othPayKodecash" label="Cash Flow">
                        <b-input-group>
                          <b-form-input readonly v-model="othPayment.obj.cashflow" @keyup.13.native="showLkuCashflow('othPayment')" :state="!$v.othPayment.obj.kodecash.$error"></b-form-input>
                          <b-input-group-append>
                            <b-btn text="Button" @click="showLkuCashflow('othPayment')" id="othPayKodecash">
                              <i class="fa fa-search"></i>
                            </b-btn>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col class="pr-4" cols="6">
                      <v-dim :model="othPayment.obj" :key="updateDimDtl"></v-dim>
                    </b-col>
                  </b-row>
                  <b-row class="justify-content-center mb-2">
                    <div style="width: 400px">
                      <b-input-group>
                        <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                        <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0" class="pt-2"></b-form-checkbox>
                        <b-input-group-append>
                          <b-button class="btn btn-success mr-1" @click="saveOthPayment()">Update</b-button>
                        </b-input-group-append>
                        <b-input-group-append>
                          <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                  </b-row>
                </b-card>
              </template>
            </b-table>
            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-button size="sm" class="ml-3" @click="addOthPayment" :disabled="!model.tanggal">Add Other Payment</b-button>
                  <div class="ml-2 mt-1">
                    Showing {{ (othPayment.page - 1) * othPayment.limit + 1 }} to <span v-if="othPayment.page * othPayment.limit > othPayment.total">{{ othPayment.total }}</span>
                    <span v-else>{{ othPayment.page * othPayment.limit }}</span> of {{ othPayment.total }} entries, <span class="mr-1">limit per page :</span>
                    <select v-model="othPayment.limit" style="width: 60px">
                      <option>5</option>
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                    </select>
                  </div>
                </b-row>
              </b-col>
              <b-col cols="6">
                <b-pagination align="right" :total-rows="othPayment.total" :per-page="othPayment.limit" v-model="othPayment.page"></b-pagination>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>
      <b-row h-align="between">
        <b-col cols="4">
          <b-form-group label-cols="3" label="Total Detail Receipt">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{ model.matauang }}</span>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="totalDtlPaym" :precision="2" disabled></my-number>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
              <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0" class="pt-2"></b-form-checkbox>
              <b-input-group-append>
                <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
              </b-input-group-append>
              <b-input-group-append>
                <button class="btn btn-danger mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="lkuArsetShow" size="xl" :hide-footer="true" title="List of AR Payment - Collection Settlement" :centered="true">
      <lku-arset @click="onSelectLkuArset" :formdata="lkuArsetData"></lku-arset>
    </b-modal>
    <b-modal v-model="lkuAdvSetShow" size="xl" :hide-footer="true" title="List of Cash Advance Settlement Outstanding Exceeds Cash" :centered="true">
      <lku-advset @click="onSelectLkuAdvSet"></lku-advset>
    </b-modal>
    <b-modal v-model="lkuCashflowShow" size="lg" :hide-footer="true" title="List of Cashflow Account" :centered="true">
      <lku-cashflow @click="onSelectLkuCashflow" :formdata="lkuCashflowData" typeacc="IN"></lku-cashflow>
    </b-modal>
    <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
      <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
    </b-modal>
    <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
      <lku-bankaccount @click="onSelectLkuBankaccount" :isbank="bankOnly" :key="bankOnly" aktif="1" :formdata="lkuBankaccountData"></lku-bankaccount>
    </b-modal>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>
<style lang="scss">
.row-details-form {
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuArset from "../lookup/lkuArsetLazzy";
import lkuAdvset from "../lookup/lkuAdvset_db.1";
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import lkuCashflow from "../lookup/lkuCashflowLazzy";
import lkuCoa from "../lookup/lkuCoa";
import tranbank from "../../apis/tranbank";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";
import arpayment from "../../apis/arpayment";
toastr.init();

export default {
  components: { Loading, myNumber, vDim, lkuArset, lkuAdvset, lkuBankaccount, lkuCashflow, lkuCoa },
  mixins: [validationMixin],
  validations: {
    model: {
      kodebank: { required },
      uraian: { required },
      tanggal: { required },
      jenis: { required },
      matauang: { required },
      terimadari: { required },
      valas_in: { required, minValue: minValue(0.01) },
      iDocsURL: {
        required: function () {
          // if (!(this.model.iDocsURL)){
          //     return false;
          // } else {
          return true;
          // }
        },
      },
      kurstrx: { required, minValue: minValue(0.00000001) },
    },
    arReceipt: {
      arpaymKey: { required },
    },
    advSetPayment: {
      obj: {
        advSttlKey: { required },
        kodecash: { required },
        nilaiByr: { required, minValue: minValue(0.01) },
        nilaiBank: { required, minValue: minValue(0.01) },
        kursBankKeAdv: { required, minValue: minValue(0.0000001) },
      },
    },
    othPayment: {
      obj: {
        kodeacc: { required },
        uraian: { required },
        kodecash: { required },
        ukeluar: { required },
      },
    },
  },
  data() {
    return {
      currency: [{ value: "IDR", text: "IDR" }],
      isLoading: false,
      showReport: false,
      reportUrl: "#",
      inputBerlanjut: 1,
      inputLineBerlanjut: 1,
      saveEnabled: true,
      jenisPaym: ["Cheque", "Giro", "Transfer", "Debet R/K", "Kredit R/K", "Tunai"],
      model: {
        jenis: "Giro",
        kodecash: this.$store.state.user.cashinflowNo || "",
        cashflow: this.$store.state.user.cashinflowNo ? `${this.$store.state.user.cashinflowNo} | ${this.$store.state.user.cashinflowNm}` : "",
        kodebank: "",
        uraian: "",
        tanggal: "",
        nomor: "",
        jenis: "",
        matauang: this.$store.state.user.matauang,
        terimadari: "",
        valas_in: 0,
        kurstrx: 1,
        iDocsURL: "",
      },
      lblExchRate: "Exch. Rate to ",
      bankOnly: 1,
      lkuBankaccountData: {},
      lkuBankaccountShow: false,
      lkuCashflowData: {},
      lkuCashflowShow: false,
      lkuCashflowCaller: "arReceipt",
      tabIndex: 0,
      tahun: new Date().getFullYear(),
      totalDtlPaym: 0,
      updateDimHdr: false,
      updateDimDtl: true,
      arReceipt: {
        arpaymKey: "",
        kodecash: "",
        cashflow: "",
        items: [],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "invoiceno",
            thStyle: "width:150px",
            label: "Invoice Number",
          },
          {
            key: "custinfo",
            label: "Customer",
            sortable: true,
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
          },
          {
            key: "nilaibyr",
            label: "Settlement Original Amt.",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "kurskeAR",
            label: "Exch.Rate to Original",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilaibank",
            label: "Settlement in Bank/Cash Amt.",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "selisihkurs",
            label: "Gain/(Loss) Exch.Rate",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "cashflow",
            label: "Cashflow Acc.",
            thStyle: "width:200px",
            sortable: true,
          },
        ],
        page: 1,
        limit: 10,
        total: 0,
      },
      lkuArsetShow: false,
      lkuArsetData: {},
      advSetPayment: {
        items: [],
        selected: {},
        obj: {
          advSttlKey: "",
          kodecash: "",
          cashflow: "",
          nilaiByr: 0,
          nilaiBank: 0,
          kursBankKeAdv: 1,
        },
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "nomor",
            thStyle: "width:150px",
            label: "AP Number",
          },
          {
            key: "keterangan",
            label: "Description",
          },
          {
            key: "iDocsURL",
            label: "iDoc",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
          },
          {
            key: "nilaiByr",
            label: "Settlement Original Amt.",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "kursBankKeAdv",
            label: "Exch.Rate to Original",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilaiBank",
            label: "Settlement in Bank/Cash Amt.",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "selisihKurs",
            label: "Gain/(Loss) Exch.Rate",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "cashflow",
            label: "Cashflow Acc.",
            thStyle: "width:200px",
            sortable: true,
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          },
        ],
        page: 1,
        limit: 5,
        total: 0,
      },
      lkuAdvSetShow: false,
      othPayment: {
        items: [],
        selected: {},
        obj: {
          kodeacc: "",
          glAccount: "",
          uraian: "",
          kodecash: "",
          cashflow: "",
          ukeluar: 0,
          DimDtl: {},
        },
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "glAccount",
            label: "GL Account",
          },
          {
            key: "ukeluar",
            label: "Settlement in Bank/Cash Amt.",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "cashflow",
            label: "Cashflow Acc.",
            thStyle: "width:200px",
            sortable: true,
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          },
        ],
        page: 1,
        limit: 5,
        total: 0,
      },
      lkuCoaShow: false,
    };
  },
  computed: {
    uanguser() {
      return this.$store.state.user.matauang;
    },
    dimension() {
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidArReceipt() {
      this.$v.arReceipt.$touch();
      return this.$v.arReceipt.$invalid;
    },
    invalidAdvSetPayment() {
      this.$v.advSetPayment.obj.$touch();
      return this.$v.advSetPayment.obj.$invalid;
    },
    invalidOthPayment() {
      this.$v.othPayment.obj.$touch();
      return this.$v.othPayment.obj.$invalid;
    },
    caraBayar() {
      return this.model.jenis;
    },
    bankkas() {
      return this.model.kodebank;
    },
  },
  watch: {
    caraBayar: function (jenis) {
      if (jenis === "Tunai") {
        this.bankOnly = "0";
      } else {
        this.bankOnly = "1";
      }
      if (this.model.isbank != this.bankOnly) {
        this.model.kodebank = "";
        this.model.namabank = "";
      }
    },
    bankkas: function (kode) {
      if (this.uanguser.trim() == this.model.matauang.trim()) {
        this.model.kurstrx = 1;
      }
    },
  },
  created: async function () {
    this.lblExchRate = `Exch. Rate to ${this.uanguser}`;

    if (this.$route.params.id) {
      toastr.info("Loading Payment Detail, please wait");
      try {
        // this.inputBerlanjut=0;
        // const [a,b,data] = await Promise.all([tranbank.currency(),tranbank.bankaccount(),await tranbank.receiptdetail(this.$route.params)]) ;
        // this.currency = a;
        // this.bankCashAcc = b;
        const [a, data] = await Promise.all([tranbank.currency(), await tranbank.receiptdetail(this.$route.params)]);
        this.currency = a;

        const row = data[0][0];
        this.saveEnabled = row.poststatus === 0;
        row.tanggal = row.tanggal ? moment(row.tanggal).format("YYYY-MM-DD") : "";
        row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format("YYYY-MM-DD") : "";
        row.tgl_terima = row.tgl_terima ? moment(row.tgl_terima).format("YYYY-MM-DD") : "";

        for (var key in row) {
          this.model[key] = row[key];
        }
        if (data[1][0]) {
          this.arReceipt.arpaymKey = data[1][0].arpaymKey;
          this.arReceipt.paymno = data[1][0].paymno;
          this.arReceipt.custinfo = data[1][0].custinfo;
          this.arReceipt.uraian = data[1][0].uraian;
          this.arReceipt.matauang = data[1][0].matauang || this.uanguser;
          this.arReceipt.totalbyr = data[1][0].totalbyr;
          this.arReceipt.settl_amt = data[1][0].settl_amt;
          // this.arReceipt.cashflow = data[1][0].cashflow;
          // console.log('this.arReceipt : ',this.arReceipt);
          if (this.model.isvoid == 1) {
            this.arReceipt.totalbyr = -1 * data[1][0].totalbyr;
            this.arReceipt.settl_amt = -1 * data[1][0].settl_amt;
          }
        }

        if (!this.model.kodecash) {
          this.model.kodecash = this.$store.state.user.cashinflowNo || "";
          this.model.cashflow = this.$store.state.user.cashinflowNo ? `${this.$store.state.user.cashinflowNo} | ${this.$store.state.user.cashinflowNm}` : "";
        }

        this.arReceipt.items = data[2];
        this.arReceipt.total = this.arReceipt.items.length;

        this.advSetPayment.items = data[3];
        this.advSetPayment.total = this.advSetPayment.items.length;

        this.othPayment.items = data[4];
        this.othPayment.total = this.othPayment.items.length;

        if (this.arReceipt.items.length > 0) {
          this.tabIndex = 0;
        } else if (this.advSetPayment.items.length > 0) {
          this.tabIndex = 1;
        } else if (this.othPayment.items.length > 0) {
          this.tabIndex = 2;
        }
        this.calcTotalDtlPaym();
        this.tanggalBerubah();
        this.updateDimHdr = !this.updateDimHdr;
        // if (this.model.jenis==='Tunai'){
        //     this.bankAccount = this.bankCashAcc.filter(r => r.isbank==0);
        // }
        // this.$forceUpdate();
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      this.currency = await tranbank.currency();
      // const [a,b] = await Promise.all([tranbank.currency(),tranbank.bankaccount()]) ;
      // this.currency = a;
      // this.bankCashAcc = b;
      // this.bankAccount = this.bankCashAcc.filter(r => r.isbank==1);
      this.model.tanggal = moment().format("YYYY-MM-DD");
      this.model.tgl_terima = moment().format("YYYY-MM-DD");
    }
  },
  methods: {
    async show_iDocs() {
      this.$show_iDocs();
    },
    async open_iDoc(doc) {
      this.$open_iDocs(doc, (state) => this.isLoading = state);
    },
    async open_iDocs() {
      this.$open_iDocs(this.model.iDocsURL, (state) => this.isLoading = state);
    },
    onSelectLkuBankaccount(lkuData) {
      this.lkuBankaccountData = lkuData;
      this.lkuBankaccountShow = false;
      this.model.kodebank = lkuData.selected.kode;
      this.model.matauang = lkuData.selected.matauang;
      this.model.namabank = lkuData.selected.namabank;
      this.model.nomorrek = lkuData.selected.nomorrek;
      this.model.isbank = lkuData.selected.isbank;
      this.lkuBankaccountShow = false;
    },
    showLkuCashflow(callerObj) {
      this.lkuCashflowShow = true;
      this.lkuCashflowCaller = callerObj;
    },
    onSelectLkuCashflow(lkuData) {
      this.lkuCashflowData = lkuData;
      this.lkuCashflowShow = false;
      if (this.lkuCashflowCaller == "model") {
        this.model.cashflow = lkuData.selected.kodecash.trim() + " | " + lkuData.selected.namacash.trim();
        this.model.kodecash = lkuData.selected.kodecash;
        this.model.namacash = lkuData.selected.namacash;
        this.arReceipt.items.forEach((inv) => {
          inv.kodecash = this.model.kodecash;
          inv.namacash = this.model.namacash;
          inv.cashflow = `${this.model.kodecash} | ${this.model.namacash}`;
        });
      } else {
        this[this.lkuCashflowCaller].obj.cashflow = lkuData.selected.kodecash.trim() + " | " + lkuData.selected.namacash.trim();
        this[this.lkuCashflowCaller].obj.kodecash = lkuData.selected.kodecash;
        this[this.lkuCashflowCaller].obj.namacash = lkuData.selected.namacash;
        if ((this.model.cashflow || "") == "") {
          this.model.cashflow = lkuData.selected.kodecash.trim() + " | " + lkuData.selected.namacash.trim();
          this.model.kodecash = lkuData.selected.kodecash;
          this.model.namacash = lkuData.selected.namacash;
        }
      }
      this.lkuCashflowShow = false;
    },
    save: async function () {
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        return;
      }
      this.isLoading = true;
      this.model.valas_in = this.model.valas_in || 0;
      this.model.bcharge = this.model.bcharge || 0;

      if (this.invalidModel) {
        console.log("validation model : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.isLoading = false;
      } else if (this.uanguser.trim() !== this.model.matauang.trim() && this.model.kurstrx == 1) {
        toastr.error(`Please fill the Exchange Rate of ${this.model.matauang}`, "ERROR MESSAGE", 10000);
        this.isLoading = false;
        // } else if (this.totalDtlPaym != parseFloat(this.model.valas_in)) {
      } else if (Math.abs(this.totalDtlPaym - (parseFloat(this.model.valas_in) + parseFloat(this.model.bcharge))) > 0.01) {
        toastr.error("[Transaction Amount] not Balance with [Total Detail Payment]", "ERROR MESSAGE");
        this.isLoading = false;
      } else {
        this.model.TableName = "tranbank";
        try {
          const dimValResult = await dimension.validate(this.model);
          if (dimValResult.success) {
            this.model.nomor = this.model.nomor || "";
            this.model.isvoid = this.model.isvoid || 0;
            this.model.poststatus = this.model.poststatus || 0;
            this.model.valas_out = this.model.valas_out || 0;
            this.model.valas_in = this.model.valas_in || 0;
            this.model.bcharge = this.model.bcharge || 0;

            const row = {};
            for (var key in this.model) {
              row[key] = this.model[key];
            }
            row.mode = "receipt";
            row.tanggal = moment(row.tanggal).format("YYYY-MM-DD");
            row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format("YYYY-MM-DD") : undefined;
            row.tgl_terima = row.tgl_terima ? moment(row.tgl_terima).format("YYYY-MM-DD") : moment(row.tanggal).format("YYYY-MM-DD");

            let newAdvSetPayments = this.advSetPayment.items.reduce((newArr, item) => {
              if ((item.advSttlKey || "") != "") {
                newArr.push(item);
              }
              return newArr;
            }, []);
            let newOthPayments = this.othPayment.items.reduce((newArr, item) => {
              if ((item.kodeacc || "") != "") {
                newArr.push(item);
              }
              return newArr;
            }, []);

            if ((this.arReceipt.arpaymKey || "") != "") {
              row.arReceipt = { arpaymKey: this.arReceipt.arpaymKey };
            }

            row.advSetPayment = newAdvSetPayments;
            row.othPayment = newOthPayments;
            const hasil = await tranbank.insert(row);
            toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save Receipt", 10000);
            this.isLoading = false;
            if (this.inputBerlanjut == 0) {
              this.close();
            } else {
              this.$bvModal
                .msgBoxConfirm("Do You want to Print Form/Voucher ?", {
                  title: "Please Confirm",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  okTitle: "YES",
                  cancelTitle: "NO",
                  footerClass: "p-2",
                  hideHeaderClose: false,
                  centered: true,
                })
                .then(async (value) => {
                  if (value == true) {
                    try {
                    this.reportUrl=null; this.showReport = true;

                      this.reportUrl = await tranbank.print(hasil);

                      // this.reportUrl = await tranbank.print(hasil);
//                       if (this.$isMobile()) {
//                         window.location.href = `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
//                       } else {
//                       this.reportUrl=null; this.showReport = true;
//                       }
                    } catch (error) {
                      if (error.message) {
                        toastr.error(error.message);
                      } else {
                        toastr.error(JSON.stringify(error));
                      }
                    }
                  }
                })
                .catch((err) => {
                  // An error occurred
                });
              this.saveEnabled = true;
              const _selected = {
                kode: this.model.kodebank,
                matauang: this.model.matauang,
                namabank: this.model.namabank,
                nomorrek: this.model.nomorrek,
                isbank: this.model.isbank,
                jenis: this.model.jenis,
              };
              for (var key in this.model) {
                this.model[key] = "";
              }
              this.model.kurstrx = 1;
              this.model.valas_in = 0;
              this.model.tanggal = moment().format("YYYY-MM-DD");
              this.model.tgl_terima = moment().format("YYYY-MM-DD");
              this.model.kodebank = _selected.kode;
              this.model.matauang = _selected.matauang;
              this.model.namabank = _selected.namabank;
              this.model.nomorrek = _selected.nomorrek;
              this.model.isbank = _selected.isbank;
              this.model.jenis = _selected.jenis;
              this.model.kodecash = this.$store.state.user.cashinflowNo || "";
              this.model.cashflow = this.$store.state.user.cashinflowNo ? `${this.$store.state.user.cashinflowNo} | ${this.$store.state.user.cashinflowNm}` : "";

              this.bankOnly = 1;
              this.tabIndex = 0;
              this.tahun = new Date().getFullYear();
              this.totalDtlPaym = 0;
              for (var key in this.arReceipt) {
                this.arReceipt[key] = "";
              }
              this.arReceipt.items = [];
              // this.arReceipt.selected= {};

              this.advSetPayment.items = [];
              this.advSetPayment.selected = {};

              this.othPayment.items = [];
              this.othPayment.selected = {};
              this.$v.model.$reset();
            }
          } else {
            console.log("dimValResult : ", dimValResult);
            var msg = dimValResult.message || "Dimension validation error";
            toastr.error(msg, "ERROR MESSAGE");
            this.isLoading = false;
          }
        } catch (error) {
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
          this.isLoading = false;
        }
      }
    },
    onSelectLkuArset: async function (lkuData) {
      this.lkuArsetData = lkuData;
      this.lkuArsetShow = false;
      this.arReceipt.arpaymKey = lkuData.selected.arpaymKey;
      this.arReceipt.paymno = lkuData.selected.paymno;
      this.arReceipt.custinfo = lkuData.selected.custinfo;
      this.arReceipt.uraian = lkuData.selected.uraian;
      this.arReceipt.totalbyr = lkuData.selected.totalbyr;
      this.arReceipt.matauang = lkuData.selected.matauang || this.uanguser;
      this.arReceipt.settl_amt = lkuData.selected.settl_amt;
      this.model.terimadari = lkuData.selected.custinfo;
      this.model.jenis = lkuData.selected.jenis;
      this.model.uraian = lkuData.selected.uraian;
      this.model.kodebank = lkuData.selected.kodebank;
      this.model.namabank = lkuData.selected.namabank;
      this.model.valas_in = lkuData.selected.totalbyr;
      this.model.matauang = lkuData.selected.matauang || this.uanguser;
      this.model.nomor_cek = lkuData.selected.nomor_cek;
      this.model.tgl_giro = lkuData.selected.tgl_giro ? moment(lkuData.selected.tgl_giro).format("YYYY-MM-DD") : "";
      if (lkuData.selected.kodecash) {
        this.model.kodecash = lkuData.selected.kodecash;
        this.model.cashflow = lkuData.selected.cashflow;
      } else {
        this.model.kodecash = this.$store.state.user.cashinflowNo || "";
        this.model.cashflow = this.$store.state.user.cashinflowNo ? `${this.$store.state.user.cashinflowNo} | ${this.$store.state.user.cashinflowNm}` : "";
      }

      if ((this.model.uraian || "") == "") {
        this.model.uraian = lkuData.selected.uraian;
      }
      if ((this.model.terimadari || "") == "") {
        this.model.terimadari = lkuData.selected.custinfo;
      }
      this.updateDimDtl2Hdr(lkuData.selected);
      this.calcTotalDtlPaym();
      // if (this.arReceipt.matauang.trim() == this.model.matauang.trim()) {
      //     this.arReceipt.kurstrx = 1;
      // }
      try {
        const data = await arpayment.arpaymdetail(lkuData.selected);
        // console.log(data);
        this.arReceipt.items = data[1];
        this.arReceipt.items.forEach((inv) => {
          inv.kodecash = this.model.kodecash ? this.model.kodecash : inv.kodecash;
          inv.namacash = this.model.kodecash ? this.model.namacash : inv.namacash;
          inv.cashflow = this.model.kodecash ? `${this.model.kodecash} | ${this.model.namacash}` : `${inv.kodecash} | ${inv.namacash}`;
        });
        this.arReceipt.total = this.arReceipt.items.length;
        // toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    closeAdvSetPayment: function () {
      const opened = this.advSetPayment.items.find((r) => r._showDetails == true);
      if (opened) opened._showDetails = false;
    },
    addAdvSetPayment: function () {
      this.closeAdvSetPayment();
      this.closeOthPayment();
      const obj = { _showDetails: true };
      this.advSetPayment.selected = obj;
      for (var key in this.advSetPayment.obj) {
        this.advSetPayment.obj[key] = "";
      }
      this.advSetPayment.items.push(obj);
      this.advSetPayment.total = this.advSetPayment.items.length;
      setTimeout(() => {
        this.advSetPayment.page = Math.ceil((this.advSetPayment.total + 1) / this.advSetPayment.limit);
        const bfore = this.advSetPayment.page;
        const after = Math.ceil(this.advSetPayment.total / this.advSetPayment.limit);
        if (bfore != after) {
          this.advSetPayment.page = after;
          toastr.info(`Move to page ${after} of total  ${this.advSetPayment.total} items`, "Detail ADV STTL. PAYMENT", 10000);
        }
      }, 100);
      this.inputLineBerlanjut = 1;
    },
    editAdvSetPayment: function (obj, callback) {
      this.closeAdvSetPayment();
      this.closeOthPayment();
      this.advSetPayment.selected = obj;
      for (var key in this.advSetPayment.obj) {
        this.advSetPayment.obj[key] = "";
      }
      for (var key in obj) {
        this.advSetPayment.obj[key] = obj[key];
      }
      this.inputLineBerlanjut = 0;
      callback();
    },
    delAdvSetPayment: function (index) {
      if (index > -1) {
        // this.advSetPayment.items.splice(index, 1);
        const posisi = (this.advSetPayment.page - 1) * this.advSetPayment.limit;
        this.advSetPayment.items.splice(posisi + index, 1);
      }
      this.advSetPayment.total = this.advSetPayment.items.length;
      this.calcTotalDtlPaym();
    },
    saveAdvSetPayment: function (callback) {
      this.advSetPayment.obj.nilaiBank = this.advSetPayment.obj.nilaiBank || 0;
      this.advSetPayment.obj.nilaiByr = this.advSetPayment.obj.nilaiByr || 0;
      // this.advSetPayment.obj.kodecash=(this.advSetPayment.obj.kodecash||'').trim();
      // if ((this.invalidAdvSetPayment) && !(this.advSetPayment.obj.kodecash)) {
      if (this.invalidAdvSetPayment) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        //    } else if (this.advSetPayment.obj.nilaiByr>this.advSetPayment.obj.outstand){
      } else if (this.advSetPayment.obj.nilaiByr - this.advSetPayment.obj.outstand > 0.01) {
        toastr.error("Receipt Amount exceeds Outstanding Amount", "ERROR MESSAGE");
      } else {
        this.advSetPayment.obj.selisihKurs = this.advSetPayment.obj.nilaiBank - this.advSetPayment.obj.nilaiByr * this.advSetPayment.obj.kursBankKeAdv;
        for (var key in this.advSetPayment.obj) {
          this.advSetPayment.selected[key] = this.advSetPayment.obj[key];
        }
        this.calcTotalDtlPaym();
        this.advSetPayment.selected._showDetails = false;
        if (callback) callback();
        if (this.inputLineBerlanjut == 1) {
          this.addAdvSetPayment();
          this.$v.advSetPayment.obj.$reset();
        }
      }
    },
    onSelectLkuAdvSet(_selected) {
      this.lkuAdvSetShow = false;
      const ada = this.advSetPayment.items.find((ap) => ap.advSttlKey == _selected.advSttlKey);
      if (ada) {
        // if (ada.advStlDtlKey!== this.advSetPayment.selected.advStlDtlKey) {
        toastr.error(`ADV SETTLEMENT Number ${_selected.nomor} already on paid list`, "ERROR MESSAGE", 10000);
        return;
        // }
      }
      this.advSetPayment.obj.advSttlKey = _selected.advSttlKey;
      this.advSetPayment.obj.nomor = _selected.nomor;
      this.advSetPayment.obj.keterangan = _selected.keterangan;
      this.advSetPayment.obj.iDocsURL = _selected.iDocsURL;
      this.advSetPayment.obj.crewkey = _selected.crewkey;
      this.advSetPayment.obj.nik = _selected.nik;
      this.advSetPayment.obj.crewinfo = _selected.crewinfo;
      this.advSetPayment.obj.matauang = _selected.matauang;
      this.advSetPayment.obj.jumlah = _selected.jumlah;
      this.advSetPayment.obj.outstand = _selected.outstand;
      this.advSetPayment.obj.nilaiByr = _selected.outstand;
      this.advSetPayment.obj.cashflow = _selected.cashflow;
      if ((this.model.uraian || "") == "") {
        this.model.uraian = _selected.keterangan;
      }
      if ((this.model.terimadari || "") == "") {
        this.model.terimadari = _selected.crewinfo;
      }
      if (_selected.kodecash) {
        this.advSetPayment.obj.kodecash = _selected.kodecash;
      }
      this.updateDimDtl2Hdr(_selected);
      // this.advSetPayment.obj.namacash=_selected.namacash;
      if ((this.model.cashflow || "") == "") {
        this.model.cashflow = this.advSetPayment.obj.cashflow;
        this.model.kodecash = this.advSetPayment.obj.kodecash;
        // this.model.namacash = this.advSetPayment.obj.namacash;
      }
      if (this.advSetPayment.obj.matauang.trim() == this.model.matauang.trim()) {
        this.advSetPayment.obj.nilaiBank = _selected.outstand;
        this.advSetPayment.obj.kursBankKeAdv = 1;
        this.advSetPayment.obj.selisihkurs = 0;
      }
    },
    updateAdvSetpaym: function () {
      if (this.advSetPayment.obj.matauang.trim() == this.model.matauang.trim()) {
        this.advSetPayment.obj.nilaiBank = this.advSetPayment.obj.nilaiByr;
        this.advSetPayment.obj.kursBankKeAdv = 1;
      }
    },
    closeOthPayment: function () {
      const opened = this.othPayment.items.find((r) => r._showDetails == true);
      if (opened) opened._showDetails = false;
    },
    addOthPayment: function () {
      this.closeAdvSetPayment();
      this.closeOthPayment();
      const obj = { _showDetails: true };
      this.othPayment.selected = obj;
      for (var key in this.othPayment.obj) {
        this.othPayment.obj[key] = "";
      }
      this.othPayment.obj.uraian = this.model.uraian;
      this.updateDimHdr2Dtl(this.othPayment.obj);
      this.othPayment.items.push(obj);
      this.othPayment.total = this.othPayment.items.length;
      setTimeout(() => {
        const bfore = this.othPayment.page;
        const after = Math.ceil(this.othPayment.total / this.othPayment.limit);
        if (bfore != after) {
          this.othPayment.page = after;
          toastr.info(`Move to page ${after} of total  ${this.othPayment.total} items`, "Detail OTHERS PAYMENT", 10000);
        }
      }, 100);
      this.inputLineBerlanjut = 1;
    },
    editOthPayment: function (obj, callback) {
      this.closeAdvSetPayment();
      this.closeOthPayment();
      this.othPayment.selected = obj;
      for (var key in this.othPayment.obj) {
        this.othPayment.obj[key] = "";
      }
      for (var key in obj) {
        this.othPayment.obj[key] = obj[key];
      }
      this.dimension.forEach((dim) => {
        if (obj[dim.value]) {
          this.othPayment.obj[dim.value] = obj[dim.value];
          this.othPayment.obj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
          this.othPayment.obj[`${dim.value}Info`] = obj[dim.value] + " | " + obj[`${dim.value}Txt`];
        }
      });
      this.inputLineBerlanjut = 0;
      callback();
    },
    delOthPayment: function (index) {
      if (index > -1) {
        // this.othPayment.items.splice(index, 1);
        const posisi = (this.othPayment.page - 1) * this.othPayment.limit;
        this.othPayment.items.splice(posisi + index, 1);
      }
      this.othPayment.total = this.othPayment.items.length;
      this.calcTotalDtlPaym();
    },
    saveOthPayment: async function (callback) {
      this.othPayment.obj.ukeluar = this.othPayment.obj.ukeluar || 0;
      // this.othPayment.obj.kodecash=(this.othPayment.obj.kodecash||'').trim();
      // if ((this.invalidOthPayment) && !(this.othPayment.obj.kodecash)) {
      //     console.log('validation othPayment : ', this.$v.othPayment.obj);
      //     console.log('othPayment Object : ',this.othPayment.obj);
      if (this.invalidOthPayment) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        let datadim = this.othPayment.obj;
        datadim.TableName = "trbankdtl";
        try {
          const dimValResult = await dimension.validate(datadim);
          if (dimValResult.success) {
            for (var key in this.othPayment.obj) {
              this.othPayment.selected[key] = this.othPayment.obj[key];
            }
            this.dimension.forEach((dim) => {
              if (datadim[dim.value]) {
                this.othPayment.selected[dim.value] = datadim[dim.value];
                this.othPayment.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
              }
            });
            this.updateDimDtl2Hdr(datadim);
            this.calcTotalDtlPaym();
            this.othPayment.selected._showDetails = false;
            if (callback) callback();
            if (this.inputLineBerlanjut == 1) {
              this.addOthPayment();
              this.$v.othPayment.obj.$reset();
            }
          } else {
            console.log("dimValResult : ", dimValResult);
            var msg = dimValResult.message;
            if (callback) callback(new Error(msg));
            else {
              toastr.error(msg, "ERROR MESSAGE");
            }
          }
        } catch (error) {
          console.log("error : ", error);
          toastr.error(JSON.stringify(error), "ERROR MESSAGE");
        }
      }
    },
    onSelectLkuCoa(_selected) {
      this.othPayment.obj.glAccount = _selected.kodeacc.trim() + " | " + _selected.namaacc.trim();
      this.othPayment.obj.kodeacc = _selected.kodeacc;
      this.othPayment.obj.namaacc = _selected.namaacc;
      this.lkuCoaShow = false;
    },

    updateDimDtl2Hdr: function (dimDtl) {
      var dimHdr = this.model;
      this.dimension.forEach((dim) => {
        if (dimDtl[dim.value] && !dimHdr[dim.value]) {
          dimHdr[dim.value] = dimDtl[dim.value];
          dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
          dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`];
        }
      });
      this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
      var dimHdr = this.model;
      dimDtl = dimDtl || this.othPayment.obj;
      this.dimension.forEach((dim) => {
        if (dimHdr[dim.value] && !dimDtl[dim.value]) {
          dimDtl[dim.value] = dimHdr[dim.value];
          dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
          dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`];
        }
      });
      this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtlPaym: function () {
      // let totalDtlPaym = this.model.bcharge || 0;
      let totalDtlPaym = 0;
      totalDtlPaym = totalDtlPaym + (this.arReceipt.totalbyr || 0);
      // this.arReceipt.items.forEach(function (trx) {
      //     if (trx.arpaymKey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaibank);
      // });
      this.advSetPayment.items.forEach(function (trx) {
        if (trx.advSttlKey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaiBank);
      });
      this.othPayment.items.forEach(function (trx) {
        if (trx.kodeacc) totalDtlPaym = totalDtlPaym + parseFloat(trx.ukeluar);
      });
      this.totalDtlPaym = totalDtlPaym;
    },
    tanggalBerubah: function () {
      this.tahun = moment(this.model.tanggal).format("YYYY");
    },
    close() {
      //   router.push({name:'treasury.trxlist'});
      if (this.$store.state.prevRoute.name) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        router.push({ name: "treasury.trxlist" });
      }
    },
  },
};
</script>
